import React, {useState, useEffect} from 'react';
import {labels, currentResource} from '../../../../util/utils';
import AuditInsightTileLayout from '../../../Common/AuditInsightTile/AuditInsightTileLayout';
import theme from '@ey/styled-theme';
import {
	auditStrategyType,
	GARoleTypeId,
	findingType,
	riskType,
	digitalAuditType,
	ProfileDigitalGAMType,
	projectSessionKeys,
	insightTypes,
	dashboardChartColors
} from '../../../../util/uiconstants';
import EngagementDetails from './EngagementDetails';
import {loadStorage, saveStorage} from '../../../Common/localStorage';
import Utility from '../../../../util/utilityfunctions';
import GenerateGroupRiskAssessmentExcel from './GenerateExcel';
import Select from '../../../CoreWrappers/Select';

const AuditInsight = (props) => {
	const [auditSightSwitcher, setAuditSightSwitcher] = useState(1);
	const [auditData, setAuditData] = useState([]);
	const projectId = Utility.getProjectIdFromUrl();
	const psessionKEy = `${projectSessionKeys.projectID}_${projectId}_${projectSessionKeys.insightSession}`;

	useEffect(() => {
		const currentState = loadStorage(psessionKEy);
		if (currentState && currentState.auditSightbyGroupFilterid) {
			setAuditSightSwitcher(currentState.auditSightbyGroupFilterid);
		}
	}, []);

	useEffect(() => {
		if (props.engagementMetrics) {
			let data = [];
			props.engagementMetrics.map((item) => {
				const itTestingTotal = item.itConTested + item.itConSubTested;
				const itNonTestingTotal = item.itConTotal - item.itConTested + (item.itConSubTotal - item.itConSubTested);
				data.push({
					engKey: item.engKey,
					engId: item.engId,
					defCount: item.defDesign + item.defOper + item.defOperAndDes,
					sDCount: item.sDDesign + item.sDOper + item.sDOperAndDes,
					mwCount: item.mWDesign + item.mWOper + item.mWOperAndDes,
					defOperAndDes: item.defOperAndDes,
					sDOperAndDes: item.sDOperAndDes,
					mWOperAndDes: item.mWOperAndDes,
					misFactCY: item.misFactCY,
					misProjCY: item.misProjCY,
					misJudgCY: item.misJudgCY,
					misReclasCY: item.misReclasCY,
					gAType: item.gAType,
					riskInherent: item.riskInherent,
					riskSigni: item.riskSigni,
					riskFraud: item.riskFraud,
					substantivePsp: item.subPsp,
					substantiveOsp: item.subOsp,
					substantiveHxPsp: item.subHxPsp,
					controlTotal: item.conTotal,
					controlTested: item.conTested,
					controlNonTested: item.conTotal - item.conTested,
					riskFraud: item.riskFraud,
					prDigtalGam: item.prDigtalGam,
					itTestingTotal: itTestingTotal,
					itConTested: item.itConTested,
					itConSubTested: item.itConSubTested,
					itNonTestingTotal: itNonTestingTotal,
					itConNonTested: item.itConTotal - item.itConTested,
					itConSubNonTested: item.itConSubTotal - item.itConSubTested
				});
			});
			setAuditData(data);
		}
	}, [props.engagementMetrics]);

	const switchAuditSight = (id) => {
		let _id = Number.parseInt(id);
		let currentState = loadStorage(psessionKEy);

		setAuditSightSwitcher(_id);

		if (!currentState) {
			currentState = {};
		}

		currentState.auditSightbyGroupFilterid = _id;
		saveStorage(psessionKEy, currentState);
	};

	const defaultSeriesDeficiency = [
		{
			name: 'DeficiencyOperationAndDesign',
			label: labels.deficiencyLabel,
			itemCount: 0,
			dataAttributeName: 'defCount',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.maroon[1]
		},
		{
			name: 'SignificantDeficiencyOperationAndDesign',
			label: labels.significantDeficiencyLabel,
			itemCount: 0,
			dataAttributeName: 'sDCount',
			statusClass: 'pendingResponse',
			percentage: 0,
			color:dashboardChartColors.maroon[2],
			customLegendClass: 'significant-legend'
		},
		{
			name: 'MaterialWeaknessOperationAndDesign',
			label: labels.materialWeaknessLabel,
			itemCount: 0,
			dataAttributeName: 'mwCount',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.maroon[3],
			customLegendClass: 'material-legend'
		}
	];

	const barStyling1 = {
		styleName: 'groupReportItem',
		chartWrapper: 'groupAuditchart'
	};

	const barStyling2 = {
		styleName: 'groupReportItem',
		chartWrapper: 'groupAuditchart'
	};

	// Risk default data
	const defaultSeriesRisk = [
		{
			name: 'InherentRisk',
			label: labels.inherenRisktLabel,
			itemCount: 0,
			dataAttributeName: 'riskInherent',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.red[1]
		},
		{
			name: 'SignificantRisk',
			label: labels.significantRiskLabel,
			itemCount: 0,
			dataAttributeName: 'riskSigni',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.red[2]
		},
		{
			name: 'FraudRisk',
			label: labels.fraudRiskLabel,
			itemCount: 0,
			dataAttributeName: 'riskFraud',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.red[3]
		}
	];
	// Risk tab initial data
	const initialDataRisk = {
		totalCount: 0,
		dataLoaded: false,
		dataFilterAttribute: 'gAType',
		totalCount1Label: labels.totalRiskLabel,
		totalCountLabel: labels.totalRisksLabel,
		allEngagementHeader: labels.allEngagementHeader,
		id: riskType.risk,
		primary: {
			typeFilterIds: [GARoleTypeId.Primary],
			chartTitleLabel: labels.auditTileHeaderTextPrimary,
			series: defaultSeriesRisk,
			barStyling: barStyling1
		},
		regionalandComponent: {
			typeFilterIds: [GARoleTypeId.Region, GARoleTypeId.Component],
			chartTitleLabel: labels.componentRegionalTeamHeader,
			series: _.cloneDeep(defaultSeriesRisk),
			barStyling: barStyling2
		}
	};
	// Initial data for Deficiency tab
	const initialDataDeficiency = {
		totalCount: 0,
		dataLoaded: false,
		dataFilterAttribute: 'gAType',
		totalCount1Label: labels.totalDeficiencyLabel,
		totalCountLabel: labels.totalDeficienciesLabel,
		allEngagementHeader: labels.allEngagementHeader,
		id: findingType.deficiency,
		primary: {
			typeFilterIds: [GARoleTypeId.Primary],
			chartTitleLabel: labels.auditTileHeaderTextPrimary,
			series: defaultSeriesDeficiency,
			barStyling: barStyling1
		},
		regionalandComponent: {
			typeFilterIds: [GARoleTypeId.Region, GARoleTypeId.Component],
			chartTitleLabel: labels.componentRegionalTeamHeader,
			series: _.cloneDeep(defaultSeriesDeficiency),
			barStyling: barStyling2
		}
	};

	const defaultMisstatementSeries = [
		{
			name: 'MisstatementFactualCurrentYear',
			label: labels.factualLabel,
			itemCount: 0,
			dataAttributeName: 'misFactCY',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.purple[1]
		},
		{
			name: 'MisstatementProjectedCurrentYear',
			label: labels.projectedLabel,
			itemCount: 0,
			dataAttributeName: 'misProjCY',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.purple[2]
		},
		{
			name: 'MisstatementJudgementalCurrentYear',
			label: labels.judgmentalLabel,
			itemCount: 0,
			dataAttributeName: 'misJudgCY',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.purple[3]
		},
		{
			name: 'MisstatementReclassificationCurrentYear',
			label: labels.reclassificationLabel,
			itemCount: 0,
			dataAttributeName: 'misReclasCY',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.purple[4],
			customLegendClass: 'reclassification-legend'
		}
	];

	// Initial data for Misstatement tab
	const initialDataMisstatement = {
		totalCount: 0,
		dataLoaded: false,
		dataFilterAttribute: 'gAType',
		totalCount1Label: labels.totalMisstatementLabel,
		totalCountLabel: labels.totalMisstatementsLabel,
		allEngagementHeader: labels.allEngagementHeader,
		id: findingType.misstatement,
		primary: {
			typeFilterIds: [GARoleTypeId.Primary],
			chartTitleLabel: labels.auditTileHeaderTextPrimary,
			series: defaultMisstatementSeries,
			barStyling: barStyling1
		},
		regionalandComponent: {
			typeFilterIds: [GARoleTypeId.Region, GARoleTypeId.Component],
			chartTitleLabel: labels.componentRegionalTeamHeader,
			barStyling: barStyling2,
			series: _.cloneDeep(defaultMisstatementSeries)
		}
	};

	const digitalAuditSeries = [
		{
			name: 'ProfileDigitalGAM',
			label: labels.yes,
			itemCount: 0,
			dataAttributeName: 'prDigtalGam',
			calculationFormula: function(dataList, attributeName) {
				let count = dataList.filter((data) => data[attributeName] == ProfileDigitalGAMType.yes);

				return count;
			},
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.green[1]
		},
		{
			name: 'ProfileDigitalGAM',
			label: labels.no,
			itemCount: 0,
			dataAttributeName: 'prDigtalGam',
			calculationFormula: function(dataList, attributeName) {
				let count = dataList.filter((data) => data[attributeName] == ProfileDigitalGAMType.no);

				return count;
			},
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.green[2]
		}
	];

	// Initial data for Deficiency tab
	const initialDataDigitalAudit = {
		totalCount: 0,
		dataLoaded: false,
		dataFilterAttribute: 'gAType',
		totalCount1Label: labels.engagement,
		totalCountLabel: labels.engagements,
		allEngagementHeader: labels.allEngagementHeader,
		id: digitalAuditType.digitalAudit,
		primary: {
			typeFilterIds: [GARoleTypeId.Primary],
			chartTitleLabel: labels.auditTileHeaderTextPrimary,
			series: digitalAuditSeries,
			barStyling: barStyling1
		},
		regionalandComponent: {
			typeFilterIds: [GARoleTypeId.Region, GARoleTypeId.Component],
			chartTitleLabel: labels.componentRegionalTeamHeader,
			series: _.cloneDeep(digitalAuditSeries),
			barStyling: barStyling2
		}
	};

	const defaultSeriesForSubstantiveProcedures = [
		{
			name: 'PSPsOperationAndDesign',
			label: labels.psps,
			itemCount: 0,
			dataAttributeName: 'substantivePsp',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.blue[1]
		},
		{
			name: 'OSPsOperationAndDesign',
			label: labels.osps,
			itemCount: 0,
			dataAttributeName: 'substantiveOsp',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.blue[2]
		},
		{
			name: 'hxpspsOperationAndDesign',
			label: labels.hxpsps,
			itemCount: 0,
			dataAttributeName: 'substantiveHxPsp',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.blue[3]
		}
	];

	// Initial data for Deficiency tab
	const initialDataSubstantiveProcedures = {
		totalCount: 0,
		dataLoaded: false,
		dataFilterAttribute: 'gAType',
		totalCount1Label: labels.totalSubstantiveProcedure,
		totalCountLabel: labels.totalSubstantiveProcedures,
		allEngagementHeader: labels.allEngagementHeader,
		id: auditStrategyType.substantiveprocedures,
		primary: {
			typeFilterIds: [GARoleTypeId.Primary],
			chartTitleLabel: labels.auditTileHeaderTextPrimary,
			series: defaultSeriesForSubstantiveProcedures,
			barStyling: barStyling1
		},
		regionalandComponent: {
			typeFilterIds: [GARoleTypeId.Region, GARoleTypeId.Component],
			chartTitleLabel: labels.componentRegionalTeamHeader,
			series: _.cloneDeep(defaultSeriesForSubstantiveProcedures),
			barStyling: barStyling2
		}
	};

	const defaultControlsSeries = [
		{
			name: 'controlstestingstrategy',
			label: labels.testing,
			itemCount: 0,
			dataAttributeName: 'controlTested',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.teal[1]
		},
		{
			name: 'controlsnontestingstrategy',
			label: labels.nonTesting,
			itemCount: 0,
			dataAttributeName: 'controlNonTested',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.teal[2]
		}
	];

	// Initial data for Misstatement tab
	const initialDataControls = {
		totalCount: 0,
		dataLoaded: false,
		dataFilterAttribute: 'gAType',
		totalCount1Label: labels.totalControl,
		totalCountLabel: labels.totalControls,
		allEngagementHeader: labels.allEngagementHeader,
		id: auditStrategyType.controls,
		primary: {
			typeFilterIds: [GARoleTypeId.Primary],
			chartTitleLabel: labels.auditTileHeaderTextPrimary,
			series: defaultControlsSeries,
			barStyling: barStyling1
		},
		regionalandComponent: {
			typeFilterIds: [GARoleTypeId.Region, GARoleTypeId.Component],
			chartTitleLabel: labels.componentRegionalTeamHeader,
			barStyling: barStyling2,
			series: _.cloneDeep(defaultControlsSeries)
		}
	};

	const defaultSeriesForITControl = [
		{
			name: 'ITControlSubstantiveTested',
			label: labels.testing,
			itemCount: 0,
			dataAttributeName: 'itTestingTotal',
			dataAttributeAppend1: 'itConTested',
			dataAttributeAppend2: 'itConSubTested',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.orange[1]
		},
		{
			name: 'TControlSubstantiveTested',
			label: labels.nonTesting,
			itemCount: 0,
			dataAttributeName: 'itNonTestingTotal',
			dataAttributeAppend1: 'itConNonTested',
			dataAttributeAppend2: 'itConSubNonTested',
			statusClass: 'pendingResponse',
			percentage: 0,
			color: dashboardChartColors.orange[2]
		}
	];

	// Initial data for Deficiency tab
	const initialDataITControls = {
		totalCount: 0,
		dataLoaded: false,
		dataFilterAttribute: 'gAType',
		totalCount1Label: labels.totalSubstantiveProcedure,
		totalCountLabel: labels.totalSubstantiveProcedures,
		allEngagementHeader: labels.allEngagementHeader,
		id: auditStrategyType.it,
		appendTooltip: (currentValue, item) => {
			let toolTip = `${currentValue} ${'</br>'} ${item[item.dataAttributeAppend1 + 'Count']} ${
				labels.controls
			}${'</br>'}${item[item.dataAttributeAppend2 + 'Count']} ${labels.substantiveProcedures}`;
			return toolTip;
		},
		primary: {
			typeFilterIds: [GARoleTypeId.Primary],
			chartTitleLabel: labels.auditTileHeaderTextPrimary,
			series: defaultSeriesForITControl,
			barStyling: barStyling1
		},
		regionalandComponent: {
			typeFilterIds: [GARoleTypeId.Region, GARoleTypeId.Component],
			chartTitleLabel: labels.componentRegionalTeamHeader,
			series: _.cloneDeep(defaultSeriesForITControl),
			barStyling: barStyling2
		}
	};

	const findingTileConfig = {
		tileTitle: labels.findingsLabel,
		toggleOptions: currentResource.findings,
		defaultToggleOption: currentResource.findings.length > 0 ? currentResource.findings[1] : {id: 0},
		chart1DataConfiguration: initialDataDeficiency,
		chart2DataConfiguration: initialDataMisstatement
	};

	const riskTileConfig = {
		tileTitle: labels.riskLabel,
		subTitle: labels.byType,
		// toggleOptions: currentResource.risks,
		defaultToggleOption: currentResource.risks.length > 0 ? currentResource.risks[1] : {id: 0},
		chart1DataConfiguration: initialDataRisk,
		chart2DataConfiguration: initialDataRisk
	};

	const auditStrategyTileConfig = {
		tileTitle: labels.auditStrategy,
		toggleOptions: currentResource.auditStrategies,
		defaultToggleOption: currentResource.auditStrategies.length > 0 ? currentResource.auditStrategies[0] : {id: 0},
		chart1DataConfiguration: initialDataSubstantiveProcedures,
		chart2DataConfiguration: initialDataControls,
		chart3DataConfiguration: initialDataITControls
	};
	const digitalAuditConfig = {
		tileTitle: labels.digitalAuditStrategy,
		subTitle: labels.basedOnProfileSelection,
		defaultToggleOption: 1,
		chart1DataConfiguration: initialDataDigitalAudit,
		chart2DataConfiguration: initialDataDigitalAudit
	};

	const renderSelect = () => {
		const selectProps = {
			value: auditSightSwitcher,
			wrapperClass: 'insight-select-filter',
			name: 'insight-select-name',
			options: currentResource.auditInsights,
			onChange: switchAuditSight
		};

		return <Select {...selectProps} />;
	};

	return (
		<>
			<div className="full">{renderSelect()}</div>
			<AuditInsightTileLayout
				dataLoading={props.isLoading}
				key={insightTypes.risk + props.isLoading}
				type={insightTypes.risk}
				auditData={auditData}
				config={riskTileConfig}
				viewType={auditSightSwitcher}
				exportDataTool={<GenerateGroupRiskAssessmentExcel />}
			/>
			<AuditInsightTileLayout
				dataLoading={props.isLoading}
				key={insightTypes.digitalAudit + props.isLoading}
				type={insightTypes.digitalAudit}
				auditData={auditData}
				config={digitalAuditConfig}
				viewType={auditSightSwitcher}
			/>
			<AuditInsightTileLayout
				dataLoading={props.isLoading}
				key={insightTypes.auditstrategy + props.isLoading}
				type={insightTypes.auditstrategy}
				auditData={auditData}
				config={auditStrategyTileConfig}
				viewType={auditSightSwitcher}
			/>
			<AuditInsightTileLayout
				dataLoading={props.isLoading}
				key={insightTypes.finding + props.isLoading}
				type={insightTypes.finding}
				auditData={auditData}
				config={findingTileConfig}
				viewType={auditSightSwitcher}
			/>
			<EngagementDetails engagementMetrics={props.engagementMetrics} />
		</>
	);
};

export default AuditInsight;
